import React from 'react';
import PopUp from './pop-up';

export const FeedBack = () => (
  <PopUp />
);



// WEBPACK FOOTER //
// ./src/components/reusable/feedback/index.js